(() => {
  'use strict';
  // Carry only approved, non-personal campaign codes through the theme. No cookies, storage or beacon.
  const allowed = {
    utm_source: new Set(['bigbear-today','facebook','instagram','facebook-group']),
    utm_medium: new Set(['referral','social','owned','organic']),
    utm_campaign: new Set(['holiday-ride-2026','ride-holiday-2026','ride-demo-2026'])
  };
  const inbound = new URLSearchParams(location.search), campaign = new URLSearchParams();
  for (const [key, values] of Object.entries(allowed)) {
    const value=inbound.get(key);
    if(value && values.has(value)) campaign.set(key,value);
  }
  if(!campaign.has('utm_source') || !campaign.has('utm_campaign'))return;
  const update=link=>{
    const raw=link.getAttribute('href');
    if(!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:'))return;
    let url;try{url=new URL(raw,location.href)}catch{return}
    if(url.origin!==location.origin || !['http:','https:'].includes(url.protocol))return;
    for(const [key,value] of campaign)url.searchParams.set(key,value);
    link.href=url.pathname+url.search+url.hash;
  };
  document.querySelectorAll('a[href]').forEach(update);
})();
